import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Card } from 'components/base';
import queryString from 'utils/queryString';
import Icon, { ICON_TYPE } from 'components/icon';
import classNames from 'classnames';
import sleep from 'utils/sleep';

import SETTINGS from '../settings';

export const prepareFamilySearchAuthUrl = (redirectUrl = '/') => {
  let url;
  if (redirectUrl != null && redirectUrl !== '/') {
    if (redirectUrl === 'referer') {
      url = [window?.location?.pathname ?? '/', window?.location?.search ?? ''].join('');
    } else {
      url = redirectUrl;
    }
  }

  const state = {
    referrer: window.location.origin.includes("localhost") ? "http://www.mycanvas.local" : window.location.origin,
  };
  if (url) {
    state.url = url;
  }

  const query = {
    response_type: 'code',
    client_id: "b00HAS5TI4NCD3MW2BKY",
    redirect_uri: "https://okclascgafqs2udh3ipsd5c4by0bgurh.lambda-url.eu-central-1.on.aws/auth",
    scope:
      "openid,profile,email,qualifies_for_affiliate_account,country",
    state: JSON.stringify(state),
  };

  return queryString.stringifyUrl('https://ident.familysearch.org/cis-web/oauth2/v3/authorization', query);
};

const SignInWithFamilySearch = props => {
  const handleOnSignInClick = async () => {
    window.location = prepareFamilySearchAuthUrl(props.redirectUrl);

    await sleep(15000);
  };

  const fullWidth = (props.className ?? '').includes('w-100');

  return (
    <div className={props.className}>
      <Button
        type="danger"
        onClick={handleOnSignInClick}
        className={classNames({
          'position-relative': fullWidth,
          'w-100': fullWidth,
          'mb-1': props.children,
        })}
      >
        <Icon
          type={ICON_TYPE.FAMILY_SEARCH}
          className={classNames({
            'position-absolute': fullWidth,
            'mr-1': !fullWidth,
          })}
          size={20}
          style={{ left: fullWidth ? 14 : undefined }}
        />
        Login with FamilySearch
      </Button>
      {props.children}
    </div>
  );
};

SignInWithFamilySearch.propTypes = {
  className: PropTypes.string,
  // redirectUrl should be custom redirect url or enum referer
  redirectUrl: PropTypes.string,
  children: PropTypes.node,
};

SignInWithFamilySearch.defaultProps = {
  redirectUrl: '/',
};

export const SignInWithFamilySearchToggler = ({ toggler, children, className }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Card className={classNames(isOpen ? 'border-black' : 'border-white', className)}>
      <Button
        type={isOpen ? 'default' : 'danger'}
        className="w-100"
        size="sm"
        onClick={() => {
          setIsOpen(val => !val);
        }}
      >
        <Icon
          type={ICON_TYPE.FAMILY_SEARCH}
          className="position-absolute"
          size={22}
          style={{ left: 14 }}
        />
        <span>Continue with FamilySearch</span>
      </Button>
      <Card.Body className={isOpen ? 'd-block' : 'd-none'}>{children}</Card.Body>
    </Card>
  );
};

export default SignInWithFamilySearch;
